import React, { createContext, useState } from 'react'
import { Occurrence } from '../pages/ClientPanel/Occurrences/OccurencesTable/types'

interface OccurrenceContextProps {
    occurrence: Occurrence | null
    setOccurrence: React.Dispatch<React.SetStateAction<Occurrence | null>>
}

export const OccurrenceContext = createContext<OccurrenceContextProps>({
    occurrence: null,
    setOccurrence: () => { return }
})

export const OccurrenceProvider: React.FC<any> = ({ children }) => {
    const [occurrence, setOccurrence] = useState<Occurrence | null>(null)

    return (
        <OccurrenceContext.Provider value={{
            occurrence,
            setOccurrence
        }}>
            {children}
        </OccurrenceContext.Provider>
    )
}
